import type { AppStep } from "@app-types/navigation.types";
import type { Activity, Level, Role, Tool } from "@app-types/activity-data.types";

type isValidProps = {
  currentStep: AppStep;
  selectedRole: Role | undefined;
  selectedTool: Tool | undefined;
  selectedLevel: Level | undefined;
  selectedActivity: Activity | undefined;
};

export const isValid = ({
  currentStep,
  selectedRole,
  selectedTool,
  selectedLevel,
  selectedActivity,
}: isValidProps) => {
  const preferenceSelections = [
    Boolean(selectedRole),
    Boolean(selectedTool),
    Boolean(selectedLevel),
    Boolean(selectedActivity),
  ];

  return preferenceSelections[currentStep - 1];
};
